export default class ItemRequiredExecutionModalCtrl {
  constructor ($scope, $mdDialog, WorkPlanModalSrv) {
  // constants
    const headData = WorkPlanModalSrv.getVariable()

    // variables
    $scope.itemActivities = headData.itemActivities

    // methods
    $scope.close = close
    $scope.toggleSubcategories = toggleSubcategories

    function close () {
      return $mdDialog.hide()
    }

    function toggleSubcategories (activities) {
      if (activities.showChilds) {
        activities.showChilds = false
      } else {
        activities.showChilds = true
      }
    }

  }
}

ItemRequiredExecutionModalCtrl.$inject = ['$scope', '$mdDialog', 'WorkPlanModalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/modals/itemRequiredExecutionModalCtrl.js